import http from './legoClient'
import fifthaveClient from './fifthaveClient'
import api, { tapestryUrl } from './api'
import utils from 'bxl-utils'

const TEMPLATE_NAME = 'lego/arch/index.html'

// 发送图片
function uploadImg(info: any, onProgress?: any) {
  return http.post(api.uploadImg, info, {
    onUploadProgress: (processEvent: any) => {
      const { total, loaded } = processEvent
      onProgress && onProgress(total, loaded)
    },
  })
}

// get ProductList
function getProductsList(productIds: string[]) {
  return http.post(api.getProducts, {
    productIds,
  })
}

// discover v3
function searchProducts(query: any, domin?: string) {
  return fifthaveClient.post(
    `${domin ? domin : ''}/api/v3/discover`,
    {
      q: utils.uri.stringify({
        ...query,
        nc: true,
      }),
    },
    {
      headers: {
        'Content-Type': 'application/x-protobuf-json',
      },
    }
  )
}

// sign in
function login(session: any) {
  return http.post(api.loginUrl, session)
}

function getWebSitesList(from = 0, to = 10, filter) {
  return http.get('/page', {
    params: {
      f: from,
      t: to,
      ...filter,
    },
  })
}

// del
function deleteWebsite(id: string) {
  return http.delete('/page/' + id)
}

//save
const saveWebInfo = (content: any) => {
  return http.post('/page/', content)
}

// get Page Content
const getWebContent = (url: string) => {
  url = url.trim().replace(/index.html$/gi, 'content.json?t=') + `?t=${new Date().getTime()}`
  return http.get(url)
}

// get Page info
const getWebInfo = (id: string, bucket?: string) => {
  return http.get(`/page/${id}${bucket ? '?bucket=' + decodeURIComponent(bucket) : ''}`)
}

// get base info
const getBaseInfo = () => {
  return http.get(api.octoUrl + '/info?')
}

// update
const updateWebInfo = (data: any) => {
  return http.post('/page/' + data.content.root.config.pageId, data)
}

// publish
const publishWebInfo = (id: string, data = {}) => {
  return http.post('/page/publish/' + id, data)
}

// template list
const getTemplateList = () => {
  const dele = encodeURIComponent('/')
  return http.get('/oss/list?prefix=lego/archVersion/&maxKeys=100&bucket=baleen&delimiter=' + dele)
}

const getMerchantPromocode = merchantId => {
  return http.get(`${api.octoUrl}/promocode/${merchantId}?active=true`, {
    headers: {
      OctoSessionKey: 'g9U1U8HtJO78rcMN1wSyOaurXG_s2BFUSI9Cu37RzR8=',
      OctoUserID: '79d562bd-d167-4539-bb8a-5a7409393e84',
    },
  })
}

const getProductImg = productId => {
  return http.get(api.getProductImg(productId))
}

const searchBrands = text => {
  return http.get(api.searchBrands(text))
}
const getCategories = () => {
  return fifthaveClient.get(api.getCategories)
}

const getArticleDetail = id => {
  return fifthaveClient.get(api.getArticleDetail(id))
}

const getSearchCombination = (queryString: string) => {
  return fifthaveClient.get(`/api/v1/_internal/combination-products/all?${queryString}`)
}

const getCombinationInfo = data =>
  fifthaveClient.post('/api/v1/board/combination-products', data, {
    baseURL: `https://tapestry-prod.bybieyang.com`,
  })
const getLegoCategories = () =>
  fifthaveClient.get(`/api/v1/recommend/category`, {
    baseURL: tapestryUrl,
  })

const uploadJson = data => http.post(api.uploadJson, data)

export default {
  TEMPLATE_NAME,
  uploadImg,
  getProductsList,
  searchProducts,
  login,
  getWebSitesList,
  saveWebInfo,
  deleteWebsite,
  getWebInfo,
  getWebContent,
  updateWebInfo,
  publishWebInfo,
  getTemplateList,
  getBaseInfo,
  getMerchantPromocode,
  getProductImg,
  searchBrands,
  getCategories,
  getArticleDetail,
  getSearchCombination,
  getCombinationInfo,
  getLegoCategories,
  uploadJson,
}
